import * as actions from "./actions";
import { Action, createReducer, on } from "@ngrx/store";
import { Practice } from "../../models/Practice";
import { User } from "../../models/User";
import { Group } from "../../models/Group";
import { Template } from "../../interfaces/template";
import { PracticeConfigInterface } from "../../interfaces/practice-config.interface";
import { PmsAppointmentType } from "../../interfaces/pms-appointment-types.interface";
import { PmsClipbpards } from "../../interfaces/pms-clipboards.interface";

export interface PracticesState {
  currentPractice: Practice | null;
  availablePractices: Practice[] | null;
  staff: User[];
  groups: Group[];
  templates: Template[];
  config: PracticeConfigInterface | null;
  appointmentTypes: PmsAppointmentType[];
  appointmentTypesLoading: boolean;
  clipboards: PmsClipbpards[];
  clipboardsLoading: boolean;
}

export const initialState: PracticesState = {
  currentPractice: null,
  availablePractices: null,
  staff: [],
  groups: [],
  templates: [],
  config: null,
  appointmentTypes: [],
  appointmentTypesLoading: false,
  clipboards: [],
  clipboardsLoading: false,
};

const practicesReducer = createReducer(
  initialState,
  on(actions.GetPracticeStaffSuccess, (state, payload) => ({
    ...state,
    staff: payload.users,
  })),
  on(actions.GetPracticeGroupsSuccess, (state, payload) => ({
    ...state,
    groups: payload.groups,
  })),
  on(actions.GetUserPracticesSuccess, (state, payload) => ({
    ...state,
    availablePractices: payload.practices,
  })),
  on(actions.SetSelectedPractice, (state, payload) => ({
    ...state,
    currentPractice: state.availablePractices ? state.availablePractices.filter(practice => practice.id == payload.practice.id)[0] : payload.practice,
  })),
  on(actions.UpdatePracticeName, (state, { id, newName }) => ({
    ...state,
    availablePractices: state.availablePractices ? state.availablePractices.map(practice => {
      if (practice.id == id) {
        return {
          ...practice,
          name: newName,
        };
      }
      return practice;
    }) : null,
    currentPractice: state.currentPractice && state.currentPractice.id == id
      ? { ...state.currentPractice, name: newName }
      : state.currentPractice,
  })),
  on(actions.UpdatePracticeTheme, (state, { id, newTheme }) => ({
    ...state,
    availablePractices: state.availablePractices ? state.availablePractices.map(practice => {
      if (practice.id == id) {
        return {
          ...practice,
          theme: newTheme,
        };
      }
      return practice;
    }) : null,
    currentPractice: state.currentPractice && state.currentPractice.id == id
      ? { ...state.currentPractice, theme: newTheme }
      : state.currentPractice,
  })),
  on(actions.GetPracticeAppointmentTypes, (state, payload) => ({
    ...state,
    appointmentTypesLoading: true
  })),
  on(actions.GetPracticeAppointmentTypesSuccess, (state, payload) => ({
    ...state,
    appointmentTypes: payload.appointmentTypes,
    appointmentTypesLoading: false
  })),
  on(actions.GetPracticeAppointmentTypesFail, (state, payload) => ({
    ...state,
    appointmentTypesLoading: false
  })),
  on(actions.UpdatePracticeFormSubmissionCount, (state, { id, formSubmissionCount }) => ({
    ...state,
    availablePractices: state.availablePractices ? state.availablePractices.map(practice => {
      if (practice.id == id) {
        return {
          ...practice,
          formSubmissionCount: formSubmissionCount,
        };
      }
      return practice;
    }) : null,
    currentPractice: state.currentPractice && state.currentPractice.id == id
    ? { ...state.currentPractice, formSubmissionCount: formSubmissionCount }
    : state.currentPractice,
  })),
  on(actions.UpdatePracticeAccentColor, (state, { id, newAccentColor }) => ({
    ...state,
    availablePractices: state.availablePractices ? state.availablePractices.map(practice => {
      if (practice.id == id) {
        return {
          ...practice,
          accentColor: newAccentColor,
        };
      }
      return practice;
    }) : null,
    currentPractice: state.currentPractice && state.currentPractice.id == id
      ? { ...state.currentPractice, accentColor: newAccentColor }
      : state.currentPractice,
  })),
  
  on(actions.SetPmsHealthy, (state, payload) => {
    if (!state.currentPractice) {
      return { ...state };
    }

    return {
      ...state,
      currentPractice: {
        ...state.currentPractice,
        pmsHealthy: payload.pmsHealthy,
      },
    };
  }),
  on(actions.ClearAvailablePractices, (state, payload) => ({
    ...state,
    availablePractices: null,
  })),
  on(actions.GetPracticeTemplatesSuccess, (state, payload) => ({
    ...state,
    templates: payload.templates,
  })),
  on(actions.GetPracticeConfigSuccess, (state, payload) => ({
    ...state,
    config: payload.config,
  })),
  on(actions.GetPracticeClipboards, (state, payload) => ({
    ...state,
    clipboardsLoading: true
  })),
  on(actions.GetPracticeClipboardsSuccess, (state, payload) => ({
    ...state,
    clipboards: payload.clipboards,
    clipboardsLoading: false
  })),
  on(actions.GetPracticeClipboardsFail, (state, payload) => ({
    ...state,
    clipboardsLoading: false
  })),
);

export function reducer(
  state: PracticesState | undefined,
  action: Action,
): PracticesState {
  return practicesReducer(state, action);
}
